<template>
	<v-card class="fill-height">
		<!-- <v-card :class="{'fill-height': $vuetify.breakpoint.mdAndUp}"> -->

		<v-card-title>
			<h3 class="headline font-weight-bold">
				{{ getObjectValue("name", user) }}
			</h3>
			<v-spacer></v-spacer>
			<v-tooltip top v-if="onEditRoute">
				<v-btn icon flat slot="activator" to="edit" append>
					<div class="v-icon">
						<fa-icon :icon="['far', 'pencil-alt']" size="xs" />
					</div>
				</v-btn>
				<span>Edit</span>
			</v-tooltip>
			<v-tooltip top v-else>
				<v-btn
					icon
					flat
					slot="activator"
					@click="$router.back()"
					append
				>
					<div class="v-icon">
						<fa-icon :icon="['far', 'times']" size="xs" />
					</div>
				</v-btn>
				<span>Cancel</span>
			</v-tooltip>

			<v-tooltip top>
				<v-btn
					color="error"
					icon
					flat
					slot="activator"
					@click="deleteUser"
					append
				>
					<div class="v-icon">
						<fa-icon :icon="['fa', 'trash']" size="xs" />
					</div>
				</v-btn>
				<span>Delete</span>
			</v-tooltip>
		</v-card-title>

		<v-fade-transition mode="out-in" appear>
			<router-view
				:key="$route.fullPath"
				:user="user"
				v-if="user"
			></router-view>
		</v-fade-transition>
	</v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
	data() {
		return {};
	},

	props: {
		id: {
			default: null
		}
	},

	methods: {
		...mapActions(["getUser"]),
		...mapActions("admin", {
			DELETE_USER: "deleteUser"
		}),
		...mapMutations(["ADD_NOTIFICATION"]),

		deleteUser() {
			this.$swal({
				title: "Are you sure?",
				html: `This will permanently delete the user and all their associated data such as orders, quotes and messages!
					<br />
					<br />
					If this user is the supervisor of other users, those users will not have a supervisor after deletion.`,
				type: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#3085d6",
				confirmButtonText: "Yes, delete it!"
			}).then(result => {
				if (result.value) {
					this.DELETE_USER(this.user.id)
						.then(() => {
							let date = Date.now();

							this.ADD_NOTIFICATION({
								show: true,
								type: "success",
								text: `User deleted successfully.`,
								id: `user-deleted-${date}`
							});

							this.$router.replace("/admin/users");
						})
						.catch(() => {
							this.$swal({
								text:
									"An error has occured while deleting user.",
								type: "error",
								confirmButtonText: "Okay"
							});
						});
				}
			});
		}
	},

	computed: {
		...mapGetters("admin", {
			SELECTED_USER: "selectedUser",
			USERS: "users"
		}),

		onEditRoute() {
			return this.$route.fullPath.indexOf("edit") === -1;
		},

		user() {
			if (!this.USERS) {
				return null;
			}

			return this.SELECTED_USER(this.id);
		}
	},

	created() {
		if (this.id) {
			const user = this.SELECTED_USER(this.id);

			if (!user) {
				this.getUser(this.id).catch(() => {
					this.$router.replace("/admin/users");
				});
			}
		}
	}
};
</script>
